import React from 'react';
import { Certification } from '../../types';
import Icon from '../../utils/icons';
import './Accomplishments.css';

interface CertCardProps {
    cert: Certification;
}

const CertCard: React.FC<CertCardProps> = ({ cert }) => {
    const inner = (
        <>
            <div className="cert-logo" style={{ background: cert.color || '#6b7280' }}>
                {cert.logo
                    ? <img src={cert.logo} alt={cert.issuer} />
                    : <span aria-hidden="true">{cert.emoji ?? <Icon name="certificate" size={20} />}</span>
                }
            </div>
            <div className="cert-info">
                <p className="cert-title">{cert.title}</p>
                <p className="cert-issuer">{cert.issuer}</p>
                {cert.date && <p className="cert-date">{cert.date}</p>}
            </div>
            {cert.link && <span className="cert-arrow" aria-hidden="true">↗</span>}
        </>
    );

    if (cert.link) {
        return (
            <a
                href={cert.link}
                target="_blank"
                rel="noopener noreferrer"
                className="cert-card"
                aria-label={`${cert.title} — ${cert.issuer}, view credential`}
            >
                {inner}
            </a>
        );
    }

    return (
        <div className="cert-card no-link" aria-label={`${cert.title} — ${cert.issuer}`}>
            {inner}
        </div>
    );
};

interface Props {
    accomplishments: { certifications: Certification[] };
}

const Accomplishments: React.FC<Props> = ({ accomplishments }) => (
    <div className="certs-wrapper">
        <div className="certs-grid">
            {accomplishments.certifications.map((cert, i) => (
                <CertCard key={i} cert={cert} />
            ))}
        </div>
    </div>
);

export default React.memo(Accomplishments);
